/**
 * useSupportContact - the tenant's escalation contact for error copy
 * (WS-9: `tenants.config.support.contact`, {name, channel}).
 *
 * Rides the shared ['tenant-config', slug] cache (useTenantConfig);
 * resolves to the generic FALLBACK_SUPPORT_CONTACT while loading, on
 * fetch failure, or when the tenant never set one. Error banners must
 * never wait on config, so there is no loading state here.
 */

import { readSupportContact, type SupportContact } from '@/lib/errorCopy';
import { useTenant } from '@/lib/auth';
import { useTenantConfig } from './useTenantConfig';

/** `enabled: false` reads only what the shared cache already holds (the
 *  app shell reads the tenant config on every signed-in page), for a screen
 *  that must not fetch anything for a person it turns away, or one that
 *  makes no call of its own for its error copy. */
export function useSupportContact({ enabled = true }: { enabled?: boolean } = {}): SupportContact {
  const { tenantSlug } = useTenant();
  const { data } = useTenantConfig(tenantSlug, { enabled });
  return readSupportContact(data?.config);
}
